/**
 * Modal com regras de premiação do Cockpit (valores dinâmicos da configuração ERP).
 */

import { ScrollText } from 'lucide-react'
import ModalERP from '../../../components/ERP/ModalERP'
import { buildCockpitPrizeRulesContent } from '../../../utils/cockpitPrizeRules'
import './CockpitPrizeRulesModal.css'

function CockpitPrizeRulesModal({ isOpen, onClose, dashboardData }) {
  const content = buildCockpitPrizeRulesContent({
    milestones: dashboardData?.milestones ?? [],
    monthlyGoal: dashboardData?.monthlyGoal ?? 0,
  })

  return (
    <ModalERP
      isOpen={isOpen}
      onClose={onClose}
      title="Regras de Premiação"
      subtitle="Valores conforme configuração vigente do ERP"
      icon={<ScrollText size={22} />}
      size="lg"
      footer={
        <button type="button" className="cockpit-prize-rules-close-btn" onClick={onClose}>
          Entendi
        </button>
      }
    >
      <div className="cockpit-prize-rules-modal">
        <p className="cockpit-prize-rules-intro">{content.title}</p>

        {content.milestoneTable.length > 0 && (
          <div className="cockpit-prize-rules-table-wrap">
            <h3 className="cockpit-prize-rules-table-title">Tabela de marcos e prêmios</h3>
            <table className="cockpit-prize-rules-table">
              <thead>
                <tr>
                  <th>Faturamento</th>
                  <th>Prêmio geral</th>
                  <th>Prêmio líder</th>
                </tr>
              </thead>
              <tbody>
                {content.milestoneTable.map((row) => (
                  <tr key={row.value}>
                    <td>{row.value}</td>
                    <td>{row.prize}</td>
                    <td>{row.topSellerPrize}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {content.metaLabel && (
              <p className="cockpit-prize-rules-meta-note">
                Meta mensal de referência: <strong>{content.metaLabel}</strong>
              </p>
            )}
          </div>
        )}

        {content.sections.map((section) => (
          <section key={section.title} className="cockpit-prize-rules-section">
            <h3 className="cockpit-prize-rules-section-title">{section.title}</h3>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph} className="cockpit-prize-rules-paragraph">
                {paragraph}
              </p>
            ))}
            {section.bullets?.length > 0 && (
              <ul className="cockpit-prize-rules-list">
                {section.bullets.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {section.footer && (
              <p className="cockpit-prize-rules-footer-note">{section.footer}</p>
            )}
          </section>
        ))}
      </div>
    </ModalERP>
  )
}

export default CockpitPrizeRulesModal
